export const server = "http://api.tasks.blisq.pt:8143";
